module.exports = __webpack_public_path__ + "static/media/segment_4.efab9d09.png";